<div class="modal-header">
  <h1 class="modal-title">Contact Us</h1>
  <button (click)="closeModal()" aria-label="Close" class="btn-close" type="button"></button>
</div>

<div class="modal-body">
  @if (message()) {
    <div class="alert alert-dismissible" [ngClass]="{ 'alert-success': isSuccessMsg(), 'alert-danger': !isSuccessMsg() }" role="alert">
      <button type="button" class="btn-close" aria-label="Close" (click)="message.set(undefined)"></button>
      <div class="alert-message">{{ message() }}</div>
    </div>
  }

  <form style="min-height: 500px" [formGroup]="form()">
    <formly-form [hidden]="isCaptchaVisible()" [form]="form()" [fields]="formFields()" />
    @if (isCaptchaVisible()) {
      <app-captcha #captcha (isValidChange)="onCaptchaComplete($event)" />
      @if (captcha.isLoading()) {
        <div class="d-flex p-2" style="height: 100%; align-items: center; justify-content: center">
          <span class="spinner-border" style="--bs5-spinner-width: 4rem; --bs5-spinner-height: 4rem"></span>
        </div>
      }
    } @else {
      <p class="text-center mt-3 mb-3" data-cy="supportMessage">
        For pharmacy technical support, please text your NPI or call {{ phone() }}
      </p>
      <chitin-checkbox [value]="agreedToConditions()" (valueChange)="agreedToConditions.set($event)" class="d-block mb-3">
        By checking this box, I consent to receive text message related to Conversations (external) message from brightscrip. You can reply
        “STOP” at any time to opt-out. Message and data rates may apply. Message frequency may vary. Text HELP for assistance. For more
        information, please visit <a href="/privacy-policy" target="_blank">Privacy Policy</a> and
        <a href="/terms-of-use" target="_blank">SMS Terms of Use</a>.
      </chitin-checkbox>
      <div class="text-center">
        <chitin-button
          label="Submit"
          (clicked)="submit()"
          [disabled]="form().invalid || !agreedToConditions()"
          [isLoading]="isSaving()"
          data-cy="submitBtn"
        />
      </div>
    }
  </form>
</div>
